module.exports = __webpack_public_path__ + "img/jala-harvest-head-sign.e4364a2c.png";